/**
 * Created by epombo on 05.04.2017.
 */
export class BlendMode {
    public static ADD: string = "add";
    public static ALPHA: string = "alpha";
    public static DARKEN: string = "darken";
    public static DIFFERENCE: string = "difference";
    public static ERASE: string = "erase";
    public static HARDLIGHT: string = "hardlight";
    public static INVERT: string = "invert";
    public static LAYER: string = "layer";
    public static LIGHTEN: string = "lighten";
    public static MULTIPLY: string = "multiply";
    public static NORMAL: string = "normal";
    public static OVERLAY: string = "overlay";
    public static SCREEN: string = "screen";
    public static SHADER: string = "shader";
    public static SUBTRACT: string = "subtract";
}
